import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { InvoiceRebService } from '../invoice-reb.service';

import { ListInvoiceRebService } from '../list.service';

@Component({
  selector: 'mcrit-gestio-invoice-reb-filters',
  templateUrl: 'invoices-reb-filters.component.html',
  styleUrls: ['invoices-reb-filters.component.css'],
  providers: []
})
export class InvoicesRebFiltersComponent implements OnInit {
  @Input() validFilters: Array<any>;
  @Output() changeFilter = new EventEmitter();

  public filterModel: any;

  constructor(public translate: TranslateService, public languageService: LanguageService, private listInvoiceService: ListInvoiceRebService,private invoicesService: InvoiceRebService) {}

  public sendActiveFilters() {
    const activeFilters = {};
    this.listInvoiceService.valFiltres={};

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => this.listInvoiceService.valFiltres[key] = this.filterModel[key]);

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => activeFilters[key] = this.listInvoiceService.valFiltres[key]);

    this.changeFilter.emit(activeFilters);
  }

  public resetActiveFilters() {
    const newFilter = {};
    for (let key of this.filterModel) {
      newFilter[key] = null;
    }
    this.listInvoiceService.valFiltres={};
    this.filterModel = newFilter;
    this.sendActiveFilters();

  }

  ngOnInit() {

    this.filterModel = this.validFilters.reduce((acum, curr) => {
        curr.inputs.forEach(inputGroup => {
          switch (inputGroup.type) {
            case 'select':
              acum[inputGroup.name] = (inputGroup.value ? inputGroup.value : null);
              break;
            default:
            inputGroup.values.forEach(input => {
              if (input.autocomplete) { }
              acum[input.name] = (input.value ? input.value : null);
            });
          }
        });

      return acum;
    }, {});
    this.sendActiveFilters();
  }

}
